import { useEffect, useRef } from "react";

// Calls `saveFn` on a fixed interval while `enabled` is true.
// The latest `saveFn` is always used (via ref), so it can read fresh state.
export function useAutoSave(enabled, saveFn, intervalMs = 60000) {
  const saveRef = useRef(saveFn);
  saveRef.current = saveFn;
  useEffect(() => {
    if (!enabled) return;
    const t = setInterval(() => saveRef.current(), intervalMs);
    return () => clearInterval(t);
  }, [enabled, intervalMs]);
}